






































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import {SERVER_HOST_QR} from '@/config';
import ITrash from '@/components/icons/ITrash.vue'
import ICopy from '@/components/icons/ICopy.vue'
import Modal from '@/components/UI/Modal.vue';
import ImageView from '@/components/UI/ImageView.vue';
import Tooltip from '@/components/UI/Tooltip.vue';

const newshards = namespace('newshards')

@Component({
  components: {
    'i-trash': ITrash,
    'i-copy': ICopy,
    Modal,
    ImageView,
    Tooltip,
  }
})
export default class DataSources extends Vue {
  @newshards.Action('deleteDataSourceFromServer') protected deleteDataSourceFromServer:any
  @Prop({type: [Object], default: {}}) protected shard!: any
  @Prop({type: [Boolean], default: false}) protected loadShardStatus!: boolean

  source:any = {}
  openModal:boolean = false
  id:string = ''
  link:string = ''
  baseURL:string = SERVER_HOST_QR

  @Watch('shard')
  position(shard:any) {
    if(this.id != shard.id) {
      this.source = {}
    }
    this.id = shard.id
  }

  copyValue(value:string) {
    let area = document.createElement('textarea');
    document.body.appendChild(area);
    area.value = value;
    area.select();
    document.execCommand("copy");
    document.body.removeChild(area);
  }

  deleteSource() {
    this.openModal = false
    let params = {
      noteId: this.source.id,
      shardId: this.shard.id
    }
    this.deleteDataSourceFromServer(params)
    this.source = {}
  }

  openDelete(source:any) {
    this.source = source
    this.openModal = true
  }

  async selectSource(source:any) {
    if(source.select) {
      this.source = {}
      this.shard.dataSources.forEach((source:any) => {
        source.select = false
      })
    } else {
      this.shard.dataSources.forEach((source:any) => {
        source.select = false
      })
      source.select = true
      this.source = source
      this.link = this.baseURL + 'media?key=' + source.imageKey + '&bucket=media'
    }
  }

}
